import { render, staticRenderFns } from "./EditableCell.vue?vue&type=template&id=bc3fefe4&scoped=true&"
import script from "./EditableCell.vue?vue&type=script&lang=ts&"
export * from "./EditableCell.vue?vue&type=script&lang=ts&"
import style0 from "./EditableCell.vue?vue&type=style&index=0&id=bc3fefe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3fefe4",
  null
  
)

export default component.exports